import React, { useMemo } from 'react';
import { ReactComponent as CalenderIcon } from '@zonofi/svg-icons/calendar-icon.svg';
import { isToday, isYesterday } from '../../helper';
import moment from 'moment';
import {
  APP_TYPE,
  DateRangeState,
  getAppType,
  RelativeTimeRange,
  useAppSelector,
} from '@zonofi/zono-money-store';
import './date-range-filter.scss';

interface FilterItem {
  id: string;
  label: React.ReactNode;
  isIcon?: boolean;
  isSelected: boolean;
  onPress: () => void;
}

interface RelativeVariantProps {
  variant: 'relative';
  selectedRange: RelativeTimeRange;
  onRangeChange: (range: RelativeTimeRange) => void;
  handleCustomRange: () => void;
}

interface DateVariantProps {
  variant: 'date';
  dateRange: DateRangeState;
  setDateRange: (val: DateRangeState) => void;
  handleCustomRange: () => void;
}

type DateRangeFilterProps = RelativeVariantProps | DateVariantProps;

export const DateRangeFilter: React.FC<DateRangeFilterProps> = (props) => {
  const appType = useAppSelector(getAppType);

  const items = useMemo<FilterItem[]>(() => {
    switch (props.variant) {
      case 'relative': {
        const { selectedRange, onRangeChange, handleCustomRange } = props;
        return [
          {
            id: 'LAST_24_HOURS',
            label: 'T',
            isSelected: selectedRange === 'LAST_24_HOURS',
            onPress: () => onRangeChange('LAST_24_HOURS'),
          },
          {
            id: 'LAST_3_DAYS',
            label: '3D',
            isSelected: selectedRange === 'LAST_3_DAYS',
            onPress: () => onRangeChange('LAST_3_DAYS'),
          },
          {
            id: 'custom',
            label: <CalenderIcon color="#ffff" />,
            isIcon: true,
            isSelected: !['LAST_24_HOURS', 'LAST_3_DAYS'].includes(
              selectedRange
            ),
            onPress: handleCustomRange,
          },
        ];
      }

      case 'date': {
        const { dateRange, setDateRange, handleCustomRange } = props;
        const todayRange = isToday(dateRange.startDate, dateRange.endDate);
        const yesterdayRange = isYesterday(
          dateRange.startDate,
          dateRange.endDate
        );
        return [
          {
            id: 'today',
            label: 'T',
            isSelected: todayRange,
            onPress: () =>
              setDateRange({
                startDate: moment().startOf('day').toDate(),
                endDate: moment().endOf('day').toDate(),
              }),
          },
          {
            id: 'yesterday',
            label: 'Y',
            isSelected: yesterdayRange,
            onPress: () =>
              setDateRange({
                startDate: moment().subtract(1, 'day').startOf('day').toDate(),
                endDate: moment().subtract(1, 'day').endOf('day').toDate(),
              }),
          },
          {
            id: 'custom',
            label: <CalenderIcon color="#ffff" />,
            isIcon: true,
            isSelected: !todayRange && !yesterdayRange,
            onPress: handleCustomRange,
          },
        ];
      }
    }
  }, [props]);

  return (
    <div
      className={`date-range-filter_container font-semibold ${
        appType === APP_TYPE.FIELDS_OPS
          ? 'field-background'
          : 'seller-background'
      }`}
    >
      {items.map(({ id, label, isIcon, isSelected, onPress }) => (
        <div
          key={id}
          className={`date-range-filter_item ${isSelected ? 'selected' : ''}`}
          onClick={onPress}
        >
          {isIcon ? (
            typeof label === 'string' ? (
              <img src={label} alt="" className="contents" />
            ) : (
              label
            )
          ) : (
            <div className="contents">{label}</div>
          )}
        </div>
      ))}
    </div>
  );
};
